import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import FormPage, { CustomGridLayout } from "../../shared/Layouts/FormPage";
import api from "../../services/api";
import Constants from "../../services/constants";

const ViewVehicleSearch = () => {
    const { id } = useParams();
    const [data, setData] = useState({
        firstName: "",
        email: "",
        mobile: "",
        permanentAddress: "",
        shippingAddress: null,
        vehicle: [],
    });

    const formatLabel = (label) =>
        label
            .replace(/_/g, " ")
            .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
            .replace(/\b\w/g, (char) => char.toUpperCase());

    const formatValue = (value) => {
        if (value === null || value === undefined || value === "") return "N/A";
        if (typeof value === "boolean") return value ? "Yes" : "No";

        if (Array.isArray(value)) {
            if (!value.length) return "N/A";
            return value
                .map((item) => (typeof item === "object" ? JSON.stringify(item) : item))
                .join(", ");
        }

        if (typeof value === "object") {
            return JSON.stringify(value);
        }

        return value;
    };

    const getDetailEntries = (details) =>
        Object.entries(details || {}).filter(([, value]) => {
            if (value === null || value === undefined || value === "") return false;
            if (Array.isArray(value)) return value.length > 0;
            if (typeof value === "object") return Object.keys(value).length > 0;
            return true;
        });

    const DetailSection = ({ title, details }) => {
        const entries = getDetailEntries(details);

        return (
            <div className="mt-4">
                <h5 className="mb-3">{title}</h5>
                {entries.length ? (
                    <div className="grid">
                        {entries.map(([key, value]) => (
                            <div className="col-12 md:col-6" key={key}>
                                <div className="border-1 surface-border border-round p-3 h-full">
                                    <div className="font-semibold text-700 mb-2">{formatLabel(key)}</div>
                                    <div className="text-900 line-height-3" style={{ wordBreak: "break-word" }}>
                                        {formatValue(value)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>N/A</p>
                )}
            </div>
        );
    };

    useEffect(() => {
        const fetchDetails = async () => {
            if (!id) return;

            const res = await api("get", Constants.END_POINT.VEHICLE_SEARCH_USERS + id);
            if (res.success && res.data) {
                setData({
                    firstName: res.data.firstName,
                    email: res.data.email,
                    mobile: res.data.mobile,
                    permanentAddress: res.data.permanentAddress,
                    shippingAddress: res.data.shippingAddress,
                    vehicle: res.data.vehicle || [],
                });
            }
        };

        fetchDetails();
    }, [id]);

    return (
        <FormPage backText="Vehicle Search Users" backTo="/vehicle-search">
            <CustomGridLayout>
                <div className="col-12 md:col-4">
                    <div className="card">
                        <div className="flex align-items-center justify-content-between">
                            <h3>User Information</h3>
                            <div className="flex align-items-center"></div>
                        </div>
                        <hr />
                        <div className="grid">
                            <p className="col-12">Name: {data?.firstName || "N/A"}</p>
                            <p className="col-12">
                                Email: {data?.email ? <a href={`mailto:${data.email}`}> {data.email}</a> : "N/A"}
                            </p>
                            <p className="col-12">
                                Mobile: {data?.mobile ? <a href={`tel:${data.mobile}`}> {data.mobile}</a> : "N/A"}
                            </p>
                            <p className="col-12">Registered RTO Address: {data?.permanentAddress || "N/A"}</p>
                            <p className="col-12">Shipping Address: N/A</p>
                        </div>
                    </div>
                </div>
                <div className="col-12 md:col-8 mx-auto">
                    <Accordion multiple className="mt-3" activeIndex={[0]}>
                        {data?.vehicle.map((vehicle, index) => (
                            <AccordionTab key={vehicle._id} header={`Vehicle Details ${index + 1}`}>
                                <div className="grid">
                                    <p className="col-12 md:col-6">Vehicle Model: {vehicle.vehicleModel?.name || "N/A"}</p>
                                    <p className="col-12 md:col-6">Vehicle Brand: {vehicle.vehicleBrand?.name || "N/A"}</p>
                                    <p className="col-12 md:col-6">Vehicle Number: {vehicle.vehicleNumber || "N/A"}</p>
                                    <p className="col-12 md:col-6">Present Address: {vehicle.presentAddress || "N/A"}</p>
                                    <p className="col-12">
                                        Registered RTO Address: {vehicle.permanentAddress || "N/A"}
                                    </p>
                                </div>
                                <DetailSection
                                    title="Vehicle Details"
                                    details={vehicle.enrichmentDetail?.vehicleDetails}
                                />
                                <DetailSection
                                    title="Insurance Details"
                                    details={vehicle.enrichmentDetail?.insuranceDetails}
                                />
                                <DetailSection
                                    title="Finance Details"
                                    details={vehicle.enrichmentDetail?.financeDetails}
                                />
                            </AccordionTab>
                        ))}
                    </Accordion>
                </div>
            </CustomGridLayout>
        </FormPage>
    );
};

export default ViewVehicleSearch;
